// Tipos compartilhados pelas abas de configuração do agente Dwight (Hydra).

export interface MemoriaItem {
  id: string; escopo: 'usuario' | 'cliente' | 'time';
  chave: string; valor: string;
  usuario_email: string | null;
  criado_em: string; atualizado_em: string; criado_por: string | null;
}

export interface BacklogItem {
  id: string; tipo: string; descricao: string; contexto: any;
  frequencia: number; status: 'aberto' | 'em_progresso' | 'feito' | 'descartado';
  criado_em: string; atualizado_em: string;
  criado_por: string | null;
  resolvido_por: string | null; resolvido_em: string | null;
}

export interface SkillCampo {
  nome: string;
  tipo: string;
  obrigatorio: boolean;
  descricao: string | null;
  enum: string[] | null;
}

export interface Skill {
  nome: string;
  descricao: string;
  tipo: 'leitura' | 'escrita';
  campos: SkillCampo[];
  stats_30d: { chamadas: number; erros: number; taxa_erro_pct: number; ultimo_uso: string | null };
}

export interface ConversaDiag {
  id: string;
  titulo: string;
  agente: 'dwight' | 'jim';
  criado_em: string;
  atualizado_em: string;
  n_mensagens: number;
  n_user: number;
  n_assist: number;
  max_duracao_ms: number | null;
  tokens_totais: number | null;
  user_sem_resposta: number;
  erros_tools: number;
  n_truncamentos: number;
  custo_estimado_usd: number | string;
  cards_total: number;
  cards_pendentes: number;
  cards_aplicados: number;
  cards_descartados: number;
  cards_com_erro: number;
  tempo_aplicacao_mediana_ms: number | string | null;
  tipo_tarefa: string | null;
  tipos_tarefa: string[] | null;
  modelo_id: string | null;
  modelos_ids: string[];
  prompt_fingerprint: string | null;
  prompt_efetivo_fingerprints: string[];
  prompt_efetivo_fingerprint: string | null;
}

export interface ConfigItem {
  chave: string;
  valor: string;
  tipo: 'texto' | 'multilinha' | 'numero' | 'json';
  descricao: string | null;
  ordem: number;
  atualizado_em: string;
  atualizado_por: string | null;
}

export interface ExemploItem {
  id: string;
  categoria: string;
  titulo: string;
  conteudo: string;
  tags: string[];
  pdf_origem?: string | null;
  criado_em: string;
  atualizado_em: string;
  criado_por: string | null;
}

export type JobLocal = {
  arquivo: File;
  status: 'aguardando' | 'uploading' | 'fila' | 'extraindo' | 'ok' | 'erro';
  job_id?: string; exemplo_id?: string; erro?: string;
};

export const CATEGORIAS = ['topografia', 'hidrometria', 'hidrologia', 'hidraulica', 'projeto', 'geral'];
